<script setup>
import { useI18n } from 'vue-i18n';
import KanbanReportWidget from 'kanban/components/reports/KanbanReportWidget.vue';
import Button from 'dashboard/components-next/button/Button.vue';

// Datas do CRM de hoje (aniversarios, recompras previstas, sazonais), com
// atalho pra abrir o contato e mandar mensagem — o "diferencial" do Inicio.
defineProps({
  dates: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const iconFor = row => {
  if (row.kind === 'campaign') return 'i-lucide-calendar-heart';
  if (row.occasion_type === 'birthday') return 'i-lucide-cake';
  if (row.occasion_type === 'interval') return 'i-lucide-repeat';
  return 'i-lucide-gift';
};
</script>

<template>
  <KanbanReportWidget
    class="!rounded-2xl !border-n-weak !bg-white dark:!bg-n-solid-2"
    :title="t('VINCTO_HOME.TODAY_DATES.TITLE')"
    :info-text="t('VINCTO_HOME.TODAY_DATES.INFO')"
    :is-loading="isLoading"
    :is-empty="!dates.length"
    :empty-text="t('VINCTO_HOME.TODAY_DATES.EMPTY')"
  >
    <ul class="flex flex-col divide-y divide-n-weak -my-2">
      <li
        v-for="(row, index) in dates"
        :key="index"
        class="flex items-center gap-3 py-2.5"
      >
        <i
          :class="iconFor(row)"
          class="w-4 h-4 flex-shrink-0 text-n-amber-11"
        />
        <div class="flex flex-col flex-1 min-w-0">
          <span class="text-sm text-n-slate-12 truncate">
            {{ row.contact?.name || row.title }}
          </span>
          <span class="text-xs text-n-slate-10 truncate">{{ row.title }}</span>
        </div>
        <Button
          v-if="row.contact"
          size="xs"
          variant="faded"
          color="slate"
          icon="i-lucide-message-circle"
          :label="t('VINCTO_HOME.TODAY_DATES.SEND_MESSAGE')"
          @click="
            $router.push({
              name: 'contacts_edit',
              params: { contactId: row.contact.id },
            })
          "
        />
      </li>
    </ul>
  </KanbanReportWidget>
</template>
